/// <amd-module name="Checks/Approvals/Client/RestClient/Approval" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   pipelinepolicy\client\approval\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Approval from "Checks/Approvals/Client/Contracts/Approval";

export interface IApprovalRestClient extends IVssRestClient {
    /**
     * Get an approval.
     * 
     * @param project - Project ID or project name
     * @param approvalId - Id of the approval.
     * @param expand - 
     */
    getApproval(project: string, approvalId: string, expand?: Approval.ApprovalDetailsExpandParameter): Promise<Approval.Approval>;
    /**
     * List Approvals. This can be used to get a set of pending approvals in a pipeline, on an user or for a resource..
     * 
     * @param project - Project ID or project name
     * @param approvalIds - List of approval Ids to get.
     * @param expand - Include these additional details in the returned objects.
     * @param assignedTo - List of user Ids approvals assigned to. Accepts user Ids, user descriptors or user emails.
     * @param state - Approval status. Returns approvals of any status if not provided
     * @param top - Maximum number of approvals to get.
     */
    queryApprovals(project: string, approvalIds?: string[], expand?: Approval.ApprovalDetailsExpandParameter, assignedTo?: string[], state?: Approval.ApprovalStatus, top?: number): Promise<Approval.Approval[]>;
    /**
     * Update approvals.
     * 
     * @param updateParameters - 
     * @param project - Project ID or project name
     */
    updateApprovals(updateParameters: Approval.ApprovalUpdateParameters[], project: string): Promise<Approval.Approval[]>;
}

class ApprovalRestClient extends RestClientBase implements IApprovalRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Get an approval.
     * 
     * @param project - Project ID or project name
     * @param approvalId - Id of the approval.
     * @param expand - 
     */
    public async getApproval(
        project: string,
        approvalId: string,
        expand?: Approval.ApprovalDetailsExpandParameter
        ): Promise<Approval.Approval> {

        const queryValues: any = {
            '$expand': expand
        };

        return this.beginRequest<Approval.Approval>({
            apiVersion: "5.1-preview.2",
            routeTemplate: "{project}/_apis/pipelines/approvals/{approvalId}",
            routeValues: {
                project: project,
                approvalId: approvalId
            },
            queryParams: queryValues
        });
    }

    /**
     * List Approvals. This can be used to get a set of pending approvals in a pipeline, on an user or for a resource..
     * 
     * @param project - Project ID or project name
     * @param approvalIds - List of approval Ids to get.
     * @param expand - Include these additional details in the returned objects.
     * @param assignedTo - List of user Ids approvals assigned to. Accepts user Ids, user descriptors or user emails.
     * @param state - Approval status. Returns approvals of any status if not provided
     * @param top - Maximum number of approvals to get.
     */
    public async queryApprovals(
        project: string,
        approvalIds?: string[],
        expand?: Approval.ApprovalDetailsExpandParameter,
        assignedTo?: string[],
        state?: Approval.ApprovalStatus,
        top?: number
        ): Promise<Approval.Approval[]> {

        const queryValues: any = {
            approvalIds: approvalIds && approvalIds.join(","),
            '$expand': expand,
            assignedTo: assignedTo && assignedTo.join(","),
            state: state,
            top: top
        };

        return this.beginRequest<Approval.Approval[]>({
            apiVersion: "5.1-preview.2",
            routeTemplate: "{project}/_apis/pipelines/approvals/{approvalId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * Update approvals.
     * 
     * @param updateParameters - 
     * @param project - Project ID or project name
     */
    public async updateApprovals(
        updateParameters: Approval.ApprovalUpdateParameters[],
        project: string
        ): Promise<Approval.Approval[]> {

        return this.beginRequest<Approval.Approval[]>({
            apiVersion: "5.1-preview.2",
            method: "PATCH",
            routeTemplate: "{project}/_apis/pipelines/approvals/{approvalId}",
            routeValues: {
                project: project
            },
            body: updateParameters
        });
    }

}

export const ApprovalClientName = "pipelinesapproval.IApprovalRestClient";

export function getApprovalClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IApprovalRestClient {
    return pageContext.getRestClient<IApprovalRestClient>(ApprovalClientName, options);
}

RestClients.add(ApprovalClientName, { 
    factory: ApprovalRestClient,
    options: {
        resourceAreaId: "5b55a9b6-2e0f-40d7-829d-3741d2b8c4e4",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
